import axios from 'axios';

axios.defaults.headers.Accept = 'application/json';
axios.defaults.headers['Content-Type'] = 'application/json';
axios.defaults.headers['Content-Transfer-Encoding'] = 'application/json';
axios.defaults.timeout = 0; // ms; 0 = no timeout

export default axios;
